var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9,
    r: 48.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 63.6 31.2-38.8h0.1v30.6h5.8v8.1h-5.8v10.7h-10.8v-10.6h-20.5zm21-15.2-5.7 7.6-1-0.4h6.2v-7.7l0.5 0.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep401);
export default __webpack_public_path__ + "static/media/step4-01.f2ddb7dcfdceeee8068d4bf953513b30.svg";
export { ForwardRef as ReactComponent };